export const workspaceColors = {
    red: "#ba6645",
    orange: "#dfa13c",
    yellow: "#d0ce6c",
    green: "#82ba78",
    blue: "#5ebbd2",
    purple: "#b27ad0",
    grey: "#818181",
    white: "rgba(0, 0, 0, 0)"
};

export const colorClassMappings = {
    white: "tabWhite",
    grey: "tabGrey",
    green: "tabGreen",
    yellow: "tabYellow",
    blue: "tabBlue",
    purple: "tabPurple",
    red: "tabRed",
    orange: "tabOrange",
}

export const getColorClassFromRgb = (rgb: string): string | null => {
    // Validate the input `rgb`
    if (typeof rgb !== 'string' || rgb.trim() === '') {
        return null;
    }

    // Find the matching key in workspaceColors for the given RGB value
    const colorKey = Object.keys(workspaceColors).find((key) => {
        const colorValue = workspaceColors[key as keyof typeof workspaceColors];
        
        // Check if the colorValue is a valid string before calling toLowerCase
        if (typeof colorValue === 'string') {
            return colorValue.toLowerCase() === rgb.toLowerCase();
        }

        return false;
    });

    // Return the corresponding class name or null if not found
    return colorKey ? colorClassMappings[colorKey as keyof typeof colorClassMappings] : null;
};
